import { useEffect, useState, useContext } from 'react';
import { Chart as ChartJS, registerables } from 'chart.js';
import { Bar } from 'react-chartjs-2'
ChartJS.register(...registerables);

export const TicketResponseRateChart = () => {

    return (
        <Bar 
            data={{
                labels: ['JAN', 'FEB', 'MAR', 'APR', 'MAY', 'JUN', 'JUL', 'AUG', 'SEPT', 'OCT', 'NOV', 'DEC'],
                datasets: [
                    {
                        label: 'Pending',
                        data: [23, 35, 50, 38, 35, 37, 70, 62, 45, 52, 24, 33],
                        backgroundColor: '#F7936F',
                        barThickness: 13.5,
                        borderColor: "rgba(0,0,0,0)",
                        borderWidth: 3,
                        borderRadius: 100,
                        
                    },
                    {
                        label: 'Resolved',
                        data: [30, 30, 50, 58, 42, 55, 34, 65, 55, 28, 64, 39],
                        backgroundColor: '#66CB9F',
                        barThickness: 13.5,
                        borderColor: "rgba(0,0,0,0)",
                        borderWidth: 3,
                        borderRadius: 100
                    },
                    {
                        label: 'Unresolved',
                        data: [20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20, 20],
                        backgroundColor: '#F16063',
                        barThickness: 13.5,
                        borderColor: "rgba(0,0,0,0)",
                        borderWidth: 3,
                        borderRadius: 100
                    }
                ]
            }}
            height="100%"
            width="100%"
            options={{
                maintainAspectRatio: false,
                responsive: true, 
                plugins: {
                    legend: {
                        align: 'end',
                        labels: {
                            boxWidth: 10,
                            boxHeight: 10,
                            color: '#425466'
                        }
                    }
                },
                scales: {
                    y: {  
                        display: true,
                        ticks: {
                            color: "#A0AEC0",
                        },
                        max: 90
                    },
                    x: {  
                        ticks: {
                            color: "#A0AEC0"
                        },
                        grid: {
                            display: false
                        }
                    }
                }
            }}
        />
    )
}
